// extracted by mini-css-extract-plugin
module.exports = {"searchForm":"Search_searchForm__2NcRR","buttons":"Search_buttons__ac8xM"};